import { color } from '@ahamove/tokens';
import type { Address } from '@ahm/api-wrappers-core';
import { ActionIcon, Box, Group, Text, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import type { ContextModalProps } from '@mantine/modals';
import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';
import { AddressAutocomplete } from '../address-autocomplete';
import { createTranslations, locales, type Locales } from '../locales';

export type FindAddressModalProps = Pick<
  ContextModalProps<{
    lang?: keyof Locales;
  }>,
  'innerProps'
> & {
  onClose?: () => void;
  onChangeAddress: (address: Address | null) => void;
};

export default function FindAddressModal({
  innerProps,
  onChangeAddress,
  onClose,
}: FindAddressModalProps) {
  const { lang = 'vi' } = innerProps;
  const isMobile = useMediaQuery('(max-width: 767px)');
  const t = createTranslations({ locales, lang });

  const [address, setAddress] = useState<Address | null>(null);
  const handleSelectAddress = (address: Address | null) => {
    setAddress(address);
    onChangeAddress(address);
    onClose?.();
  };

  return (
    <>
      {/* TODO: Modal header  */}
      <Group
        pos={'relative'}
        w="100%"
        px={rem(8)}
        py={0}
        bg="white"
        mih={46}
        style={(theme) => ({
          border: `1px solid ${theme.colors.neutral[0]}`,
          textAlign: 'center',
        })}
      >
        <Text c="neutral.9" w={'100%'} fz={rem(18)} fw={700}>
          {t('delivery_point')}
        </Text>
        <ActionIcon
          size={44}
          variant="transparent"
          style={{
            outline: 'none !important',
            position: 'absolute',
            top: '50%',
            left: isMobile ? 0 : 'auto',
            transform: `translateY(-50%)`,
            right: 0,
          }}
          onClick={onClose}
        >
          <ArrowLeft size={24} color={color.neutral['70']} />
        </ActionIcon>
      </Group>
      <Box
        w="100%"
        style={{
          zIndex: 11,
          background: 'white',
          boxShadow: `rgba(0, 0, 0, 0.12) 0px 8px 32px`,
        }}
      >
        <AddressAutocomplete
          withinPortal={true}
          lang="vi"
          pointType="dropoff"
          placeholder={t('address')}
          withSavedPlace={false}
          isMobile
          isCurrentLocation={false}
          address={address}
          label={undefined}
          opened={true}
          onChange={handleSelectAddress}
        />
      </Box>
    </>
  );
}
